import React, {useState, useEffect} from 'react';
import {
    Box,
    Card,
    CardContent,
    Grid,
    TextField,
    Button,
    IconButton,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const JobInput = ({value, onChange}) => {
    const [jobs, setJobs] = useState([]);

    // Effect to parse the incoming JSON string value into the local state
    useEffect(() => {
        try {
            const parsedJobs = JSON.parse(value);
            if (Array.isArray(parsedJobs)) {
                setJobs(parsedJobs);
            } else {
                setJobs([]);
            }
        } catch (error) {
            setJobs([]);
        }
    }, [value]);

    // Function to notify the parent form of changes
    const handleJobsChange = (updatedJobs) => {
        setJobs(updatedJobs);
        // Create a synthetic event object for the parent's handleChange
        const event = {
            target: {
                name: 'job',
                value: JSON.stringify(updatedJobs, null, 2),
            },
        };
        onChange(event);
    };

    const handleAddJob = () => {
        const newJobs = [...jobs, {title: '', status: 'employed', hours: '40'}];
        handleJobsChange(newJobs);
    };

    const handleRemoveJob = (index) => {
        const newJobs = jobs.filter((_, i) => i !== index);
        handleJobsChange(newJobs);
    };

    const handleJobDetailChange = (index, field, fieldValue) => {
        const newJobs = [...jobs];
        newJobs[index][field] = fieldValue;
        handleJobsChange(newJobs);
    };

    return (
        <Box sx={{border: '1px solid #ccc', borderRadius: 1, p: 2}}>
            <Typography variant="h6" gutterBottom>
                Job Information
            </Typography>
            {jobs.map((job, index) => (
                <Card key={index} sx={{mb: 2}}>
                    <CardContent>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={5}>
                                <TextField
                                    label="Job Title"
                                    variant="outlined"
                                    fullWidth
                                    value={job.title}
                                    onChange={(e) =>
                                        handleJobDetailChange(index, 'title', e.target.value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        value={job.status}
                                        onChange={(e) =>
                                            handleJobDetailChange(index, 'status', e.target.value)
                                        }
                                    >
                                        <MenuItem value="employed">Employed</MenuItem>
                                        <MenuItem value="self-employed">Self-employed</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Hours/Week"
                                    type="number"
                                    variant="outlined"
                                    fullWidth
                                    value={job.hours}
                                    inputProps={{step: '0.1'}}
                                    onChange={(e) =>
                                        handleJobDetailChange(index, 'hours', e.target.value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <IconButton
                                    aria-label="delete job"
                                    onClick={() => handleRemoveJob(index)}
                                >
                                    <DeleteIcon/>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            ))}
            <Button
                startIcon={<AddCircleOutlineIcon/>}
                onClick={handleAddJob}
                variant="outlined"
            >
                Add Job
            </Button>
        </Box>
    );
};

export default JobInput;
